import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitUser = class PitUser {
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitUser.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "oid", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "login", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "fio", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "email", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "phone", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "post", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitUser.prototype, "description", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitUser.prototype, "isLocked", void 0);
PitUser = tslib_1.__decorate([
    jsonObject
], PitUser);
export { PitUser };
